<template>
    <div :class="['sol-item animated u-flex', type == 'left' ? 'slideInLeft' : 'slideInRight' ]" v-cloak>
      <div class="sol-icon">
      <!-- <img src="" alt=""> -->
      </div>
      <div>
        <p class="sol-item-title">{{ title }}</p>
        <p class="sol-item-msg">{{ content }}</p>
        <slot name="content"></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SolItem",
    props:{//props列表
        content:String,
        title:String,
        type:String
    },
    data() {
      return {

      };
    },
    mounted() {
    },
    methods: {
    }
  };
  </script>
  <style scoped>
  .sol-item{
    padding: 30px 20px;
    box-sizing: border-box;
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    margin-bottom: 30px;
    width: 100%;
  }
  .sol-icon{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 20px;
    background: #FFA000;
    flex-shrink: 0;
  }
  .sol-item-title{
    transition: all 0.3s;
    margin-bottom: 10px;
    font-weight: bold;
  }
  /* .sol-item:hover .sol-item-title{
    color: #009DE4;
  } */
  .sol-item-msg{
    font-size: 14px;
    line-height: 2;
    color: #666;
  }
  .animated {
    animation-duration: 1.5s;
    animation-fill-mode: both;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/solItem.vue